import React from 'react';

interface FitColumnsIconProps {
    width?: string | number;
    height?: string | number;
}

// Sheet editor toolbar "fit column to content" icon — inherits the toolbar's
// own text colour (no `colour` prop) via `stroke="currentColor"`.
const FitColumnsIcon = ({ width = 16, height = 16 }: FitColumnsIconProps) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 2.5v11M13.5 2.5v11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        <path
            d="M5 8h6M6.8 6.2 5 8l1.8 1.8M9.2 6.2 11 8l-1.8 1.8"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default FitColumnsIcon;
